import React from "react";
import { Row, Col, Card, Button } from "antd";
import { SolutionOutlined, TeamOutlined, BookOutlined, FolderOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
export const QuickActions = ({ darkMode }) => {
  const navigate = useNavigate();
  const handleClick = (label) => {
    if (label === "Training") {
      navigate("/trainings");
    } else if (label === "Training Library") {
      navigate("/training-library");
    } else if (label === "Total Learners") {
      navigate("/total-learners");
    } else if (label === "Business Groups") {
      navigate("/business-groups");
    }
  };
  const actions = [
    { label: "Total Learners", icon: <SolutionOutlined />, clickable: true },
    { label: "Business Groups", icon: <TeamOutlined />, clickable: true },
    { label: "Training", icon: <BookOutlined />, clickable: true },
    { label: "Training Library", icon: <FolderOutlined />, clickable: true },
  ];
  const styles = {
    card: {
      borderRadius: 8,
      marginBottom: 10,
      backgroundColor: darkMode ? "#1f1f1f" : "#fff",
      borderColor: darkMode ? "#303030" : "#f0f0f0",
    },
    cardTitle: {
      color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
    },
    actionButton: {
      height: "auto",
      padding: "12px 8px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      whiteSpace: "normal", // for better wrapping of long labels
    },
  };
  return (
    <Col xs={24} lg={16}>
      <Card title="Quick Actions" style={styles.card} styles={{ header: styles.cardTitle }}>
        <Row gutter={[16, 16]}>
          {actions.map((action, index) => (
            <Col key={index} xs={12} sm={8} md={6}>
              <Button
                type="primary"
                block
                icon={action.icon}
                style={styles.actionButton}
                onClick={action.clickable ? () => handleClick(action.label) : undefined}
              >
                {action.label}
              </Button>
            </Col>
          ))}
        </Row>
      </Card>
    </Col>
  );
};
QuickActions.propTypes = {
  darkMode: PropTypes.bool.isRequired,
};
